import { FC } from "react";
import { Select } from "..";
import { Mindset } from "../../../types/enums/Mindset";

type Props = {
    value: Mindset | undefined;
    onChanged: (value: Mindset | undefined) => void;
};

const MindsetSelect: FC<Props> = ({ value, onChanged }) => {
    return (
        <Select
            value={value}
            onChanged={(v) => onChanged(v as Mindset | undefined)}
        >
            <option value={""}>-</option>
            {Object.entries(Mindset).map(([key, value]) => (
                <option key={key} value={key}>
                    {value}
                </option>
            ))}
        </Select>
    );
};

export default MindsetSelect;
